export default __webpack_public_path__ + "static/media/android.aeb608bc.svg";